import React, { useLayoutEffect, useState } from "react";
import { Card, Divider } from "antd";
import { useParams, Link, useNavigate } from "react-router-dom";

import { LoadingComponent } from "@/components/ui/LoadingComponent";
import jobService from "@/services/JobService";
import { DetailJobTitleMB } from "@/pages/job/detailJob/components/DetailJobTitleMB";
import { DetailJobTitle } from "@/pages/job/detailJob/components/DetailJobTitle";
import { JobDescription } from "@/pages/job/detailJob/components/JobDescription/JobDescription";
import config from "@/config";
import JobService from "@/services/JobService";

const DetailJob = () => {
    const navigate = useNavigate();

    const { id } = useParams();

    const [jobByCompany, setJobByCompany] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [job, setJob] = useState({});
    const [loading, setLoading] = useState(true);

    useLayoutEffect(() => {
        // lấy chi tiết công việc
        jobService.getJobById(id).then((res) => {
            setJob(res.Data);
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }).catch((err) => {
            console.log(err)
            setLoading(false);
        });
    }, [id]);

    useLayoutEffect(() => {
        if (job.CompanyPk) {
            jobService.getJobByCompany(job.CompanyPk).then((res) => {
                setJobByCompany(res.Data);
            }).catch((err) => {
                console.error(err);
            });
        }
    }, [job.CompanyPk]);

    useLayoutEffect(() => {
        JobService.getJobWithPagination(0, 6).then((res) => {
            setJobs(res.Data);
        }).catch((err) => {
            console.error(err);
        });
    }, []);

    if (loading) {
        return <LoadingComponent />
    }

    const handleNavigate = (id) => {
        setLoading(true);
        navigate(config.routes.job + `/${id}`, { replace: true });
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }

    return (
        <div className={"bg-gray-100"}>
            <div className="container mx-auto py-10 px-4 sm:px-2 md:px-4">
                {/* Banner Section */}
                <Card className="rounded-xl mb-4">
                    <div className="container mx-auto">
                        <img
                            src={job.banner || config.webConfig.defaultIcon}
                            alt="banner"
                            className="w-full max-h-56 rounded-t-xl object-cover"
                        />
                        <div className="lg:ms-8 block -mt-16">
                            <div className={"flex w-full bg"}>
                                <DetailJobTitleMB job={job} />
                                <DetailJobTitle job={job} />
                            </div>
                        </div>
                    </div>
                </Card>

                {/* Main Content */}
                <div className="flex flex-col-reverse lg:flex-row gap-4">
                    {/* Job Details */}
                    <JobDescription job={job} handleClick={handleNavigate} jobs={jobs} jobByCompany={jobByCompany} />
                    <div className={"lg:w-1/3 w-full flex flex-row gap-4 lg:flex-col  aside-groups"}>
                        {/* Sidebar1  */}
                        <div className="w-1/2 lg:w-full bg-white p-6 rounded-lg block shadow">
                            <h2 className="text-xl font-bold mb-4">Thông tin công ty</h2>
                            <Divider
                                style={{
                                    borderColor: '#7cb305',
                                }} />
                            <div className={"flex items-center"}>
                                <img src={'/' + job.Image} alt="company-logo" className="w-16" />
                                <h2 className="text-xl font-bold ms-4 ">{job.CompanyName}</h2>
                            </div>
                            <ul className="space-y-4 text-gray-600 mt-2">
                                <li>
                                    <strong>Địa chỉ:</strong> {job.Address}
                                </li>
                                <li>
                                    <strong>Điện thoại:</strong> {job.ContactPhone}
                                </li>
                                <li>
                                    <strong>Email:</strong>
                                    <a href="mailto:" className="text-cyan-400">
                                        {job.ContactEmail}
                                    </a></li>
                            </ul>
                            <div className="mt-4 justify-center text-center">
                                <Link to={config.routes.company + `${job.CompanyPk}`}
                                    className="text-green-600 font-bold text-lg hover:underline">
                                    Xem thông tin công ty <i
                                        className="ml-3 fa-solid fa-arrow-up-right-from-square"></i>
                                </Link>
                            </div>
                        </div>
                        {/* Sidebar2  */}
                        <div className="w-1/2 lg:w-full bg-white p-6 rounded-lg block shadow">
                            <h2 className="text-xl font-bold mb-4">Thông tin chung</h2>
                            <Divider
                                style={{
                                    borderColor: '#7cb305',
                                }} />
                            <ul className="space-y-4 text-gray-600">
                                <li>
                                    <strong>Vị trí/Cấp bậc:</strong> {job.JobPosition}
                                </li>
                                <li>
                                    <strong>Học vấn:</strong> <span dangerouslySetInnerHTML={{ __html: job.RequestLevel }} />
                                </li>
                                <li>
                                    <strong>Số lượng tuyển:</strong> {job.JobQuantity}
                                </li>
                                <li>
                                    <strong>Hình thức làm việc:</strong> {job.WorkingTime}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailJob;
